module.exports = __webpack_public_path__ + "img/new_spotd4.5cbb5261.gif";